import styled from 'styled-components'

export const SubmitText = styled.p`
  font-size: 2em;
  text-align: center;
  margin: 0 1em;
  vertical-align: auto;
  font-size: clamp(1em, 5vw, 1.5em);

  span {
    font-weight: 900;
  }
`;